module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ImageComponent",
    class: _vm.classes,
    style: (_vm.styles),
    on: {
      "mouseenter": _vm.handleMouseEnter,
      "mouseleave": _vm.handleMouseLeave
    }
  }, [(_vm.smugmug) ? _c('canvas', {
    ref: "preview",
    staticClass: "ImageComponent-preview",
    style: (_vm.previewStyles),
    attrs: {
      "width": _vm.preview.width,
      "height": _vm.preview.height
    }
  }) : _vm._e(), _vm._v(" "), (_vm.resolvedSrc) ? _c('img', {
    ref: "image",
    staticClass: "ImageComponent-image",
    class: _vm.imageClasses,
    style: (_vm.imageStyles),
    attrs: {
      "data-src": _vm.resolvedSrc,
      "alt": _vm.resolvedAlt
    }
  }) : _vm._e(), _vm._v(" "), (_vm.resolvedSrcSet) ? _c('img', {
    ref: "image",
    staticClass: "ImageComponent-image",
    class: _vm.imageClasses,
    style: (_vm.imageStyles),
    attrs: {
      "data-sizes": "auto",
      "data-srcset": _vm.resolvedSrcSet,
      "alt": _vm.resolvedAlt
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28395061"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageComponent.vue
// module id = 750
// module chunks = 1474